import { render } from "./AddTermsView.vue?vue&type=template&id=7a0766d3&scoped=true"
import script from "./AddTermsView.vue?vue&type=script&lang=js"
export * from "./AddTermsView.vue?vue&type=script&lang=js"

import "./AddTermsView.vue?vue&type=style&index=0&id=7a0766d3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0766d3"]])

export default __exports__